import http from 'http'
import filter from 'src/utils/filter'
import server from 'src/utils/server'

export const getInvoicesByContract = (params) => {
  return http.get(server.url_to('contracts/' + params.id + '/invoices'))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const getInvoicesByCustomer = (params) => {
  return http.get(server.url_to('customers/' + params.subscriber_id + '/invoices?' + filter.toQuery(params.pagination)))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const newInvoice = (params) => {
  return http.post(server.url_to('contracts/' + params.contract_id + '/invoices'), params)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const updateCorpDueDateInvoice = (params) => {
  return http.put(server.url_to('invoices/' + params.invoice_id + '/update_corp_due_date'), params)
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const changeDueDate = (params) => {
  return http.post(server.url_to('contracts/' + params.contract_id + '/invoices/' + params.id + '/regenerate_order'), params)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const getInvoice = (params) => {
  return http.get(server.url_to('contracts/' + params.contract_id + '/invoices/' + params.invoice_id))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const getBillet = (params) => {
  return http.post(server.url_to('payments/invoice/' + params.invoice_id), params)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const confirmInvoice = (params) => {
  return http.post(server.url_to('invoices/' + params.invoice_id + '/confirm/'))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const cancelInvoice = (params) => {
  return http.post(server.url_to('invoices/' + params.invoice_id + '/cancel/'), params)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const reverseInvoice = (params) => {
  return http.post(server.url_to('invoices/' + params.id + '/reverse'), params)
  .then((response) => {
    return response
  })
  .catch((error) => {
    return error.response
  })
}

export const verifyOrders = (params) => {
  return http.post(server.url_to('invoices/' + params.invoice_id + '/verify_orders/'))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const paginateInvoices = (params) => {
  return http.get(server.url_to('invoices/?' + params))
  .then((response) => {
    return response
  })
  .catch((error) => {
    return error.response
  })
}

export const getInvoiceById = (params) => {
  return http.get(server.url_to('/invoices/' + params.invoice_id))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const createTaxInvoice = (params) => {
  return http.post(server.url_to('invoices/' + params.invoice_id + '/service_tax_invoice/'))
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const cancelTaxInvoice = (params) => {
  return http.post(server.url_to('tax_invoice/service_tax_invoices/' + params.id + '/cancel'), params)
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const consultServiceTaxInvoice = (params) => {
  return http.get(server.url_to('tax_invoice/service_tax_invoices/' + params.id + '/download'), { responseType: 'arraybuffer' })
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const getInvoicesCsv = (params) => {
  return http.get(server.url_to('invoices.csv/?' + params))
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}



// WEBPACK FOOTER //
// ./src/app/pages/invoices/services.js